import React from 'react';
import { Outlet } from 'react-router-dom';
import SupportNavbar from './SupportNavbar';
import './SupportLayout.css';
import { FlagSystemCapabilityProvider } from '../contexts/FlagSystemCapabilityContext';

const SupportLayout = () => {
	return (
		<div className="support-shell">
			<FlagSystemCapabilityProvider>
				<SupportNavbar />
				<Outlet />
			</FlagSystemCapabilityProvider>
		</div>
	);
};

export default SupportLayout;
